import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3623a256 = () => interopDefault(import('../pages/content/amlpolicy.vue' /* webpackChunkName: "pages/content/amlpolicy" */))
const _00e650b4 = () => interopDefault(import('../pages/cashbox/index.vue' /* webpackChunkName: "pages/cashbox/index" */))
const _76e7056e = () => interopDefault(import('../pages/error-game.vue' /* webpackChunkName: "pages/error-game" */))
const _8fe4e58e = () => interopDefault(import('../pages/content/faq.vue' /* webpackChunkName: "pages/content/faq" */))
const _dabf39ee = () => interopDefault(import('../pages/content/game-rules.vue' /* webpackChunkName: "pages/content/game-rules" */))
const _f5defaf6 = () => interopDefault(import('../pages/content/intellectual-property.vue' /* webpackChunkName: "pages/content/intellectual-property" */))
const _5a67bb64 = () => interopDefault(import('../pages/content/license.vue' /* webpackChunkName: "pages/content/license" */))
const _c07793d0 = () => interopDefault(import('../pages/content/partners.vue' /* webpackChunkName: "pages/content/partners" */))
const _572e72c4 = () => interopDefault(import('../pages/content/privacy-policy.vue' /* webpackChunkName: "pages/content/privacy-policy" */))
const _bc5f4b3c = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _0a161de3 = () => interopDefault(import('../pages/profile/bonuses/index.vue' /* webpackChunkName: "pages/profile/bonuses/index" */))
const _05920c38 = () => interopDefault(import('../pages/profile/kycaid.vue' /* webpackChunkName: "pages/profile/kycaid" */))
const _4f1990e3 = () => interopDefault(import('../pages/profile/settings/index.vue' /* webpackChunkName: "pages/profile/settings/index" */))
const _59e814a4 = () => interopDefault(import('../pages/profile/support-faq/index.vue' /* webpackChunkName: "pages/profile/support-faq/index" */))
const _02b24dca = () => interopDefault(import('../pages/promotions/index.vue' /* webpackChunkName: "pages/promotions/index" */))
const _45700e60 = () => interopDefault(import('../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _fe2e16da = () => interopDefault(import('../pages/content/responsible-gaming.vue' /* webpackChunkName: "pages/content/responsible-gaming" */))
const _f3211d6a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _50bcfbda = () => interopDefault(import('../pages/content/rules.vue' /* webpackChunkName: "pages/content/rules" */))
const _06b43ff4 = () => interopDefault(import('../pages/verifications/index.vue' /* webpackChunkName: "pages/verifications/index" */))
const _3f7c0e00 = () => interopDefault(import('../pages/cashbox/deposit.vue' /* webpackChunkName: "pages/cashbox/deposit" */))
const _6470f0f6 = () => interopDefault(import('../pages/cashbox/history.vue' /* webpackChunkName: "pages/cashbox/history" */))
const _a9c0ed2c = () => interopDefault(import('../pages/cashbox/payin-error.vue' /* webpackChunkName: "pages/cashbox/payin-error" */))
const _d306ea58 = () => interopDefault(import('../pages/cashbox/payin-status-ext.vue' /* webpackChunkName: "pages/cashbox/payin-status-ext" */))
const _cc191136 = () => interopDefault(import('../pages/cashbox/payin-success.vue' /* webpackChunkName: "pages/cashbox/payin-success" */))
const _76d433af = () => interopDefault(import('../pages/cashbox/payout-error.vue' /* webpackChunkName: "pages/cashbox/payout-error" */))
const _4b26a46a = () => interopDefault(import('../pages/cashbox/payout-success.vue' /* webpackChunkName: "pages/cashbox/payout-success" */))
const _3dc5129e = () => interopDefault(import('../pages/cashbox/support.vue' /* webpackChunkName: "pages/cashbox/support" */))
const _7107fcc3 = () => interopDefault(import('../pages/cashbox/withdrawal.vue' /* webpackChunkName: "pages/cashbox/withdrawal" */))
const _e8379f42 = () => interopDefault(import('../pages/promotions/welcome-pack/index.vue' /* webpackChunkName: "pages/promotions/welcome-pack/index" */))
const _d4a39b76 = () => interopDefault(import('../pages/game/_term.vue' /* webpackChunkName: "pages/game/_term" */))
const _36a995d4 = () => interopDefault(import('../pages/lobby/_section.vue' /* webpackChunkName: "pages/lobby/_section" */))
const _43688dbc = () => interopDefault(import('../pages/lobby/_section/_sub-section.vue' /* webpackChunkName: "pages/lobby/_section/_sub-section" */))
const _1c71847a = () => interopDefault(import('../pages/promotions/_term.vue' /* webpackChunkName: "pages/promotions/_term" */))
const _6892517c = () => interopDefault(import('../pages/auth/_social/cb.vue' /* webpackChunkName: "pages/auth/_social/cb" */))
const _7b3cc337 = () => interopDefault(import('../pages/lobby' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/amlpolicy",
    component: _3623a256,
    name: "content-amlpolicy___ua"
  }, {
    path: "/cashbox",
    component: _00e650b4,
    name: "cashbox___ua"
  }, {
    path: "/error-game",
    component: _76e7056e,
    name: "error-game___ua"
  }, {
    path: "/faq",
    component: _8fe4e58e,
    name: "content-faq___ua"
  }, {
    path: "/game-rules",
    component: _dabf39ee,
    name: "content-game-rules___ua"
  }, {
    path: "/intellectual-property",
    component: _f5defaf6,
    name: "content-intellectual-property___ua"
  }, {
    path: "/license",
    component: _5a67bb64,
    name: "content-license___ua"
  }, {
    path: "/partners",
    component: _c07793d0,
    name: "content-partners___ua"
  }, {
    path: "/privacy-policy",
    component: _572e72c4,
    name: "content-privacy-policy___ua"
  }, {
    path: "/profile",
    component: _bc5f4b3c,
    name: "profile___ua",
    children: [{
      path: "bonuses",
      component: _0a161de3,
      name: "profile-bonuses___ua"
    }, {
      path: "kycaid",
      component: _05920c38,
      name: "profile-kycaid___ua"
    }, {
      path: "settings",
      component: _4f1990e3,
      name: "profile-settings___ua"
    }, {
      path: "support-faq",
      component: _59e814a4,
      name: "profile-support-faq___ua"
    }]
  }, {
    path: "/promotions",
    component: _02b24dca,
    name: "promotions___ua"
  }, {
    path: "/registration",
    component: _45700e60,
    name: "registration___ua"
  }, {
    path: "/responsible-gaming",
    component: _fe2e16da,
    name: "content-responsible-gaming___ua"
  }, {
    path: "/ru",
    component: _f3211d6a,
    name: "index___ru"
  }, {
    path: "/rules",
    component: _50bcfbda,
    name: "content-rules___ua"
  }, {
    path: "/verifications",
    component: _06b43ff4,
    name: "verifications___ua"
  }, {
    path: "/cashbox/deposit",
    component: _3f7c0e00,
    name: "cashbox-deposit___ua"
  }, {
    path: "/cashbox/history",
    component: _6470f0f6,
    name: "cashbox-history___ua"
  }, {
    path: "/cashbox/payin-error",
    component: _a9c0ed2c,
    name: "cashbox-payin-error___ua"
  }, {
    path: "/cashbox/payin-status-ext",
    component: _d306ea58,
    name: "cashbox-payin-status-ext___ua"
  }, {
    path: "/cashbox/payin-success",
    component: _cc191136,
    name: "cashbox-payin-success___ua"
  }, {
    path: "/cashbox/payout-error",
    component: _76d433af,
    name: "cashbox-payout-error___ua"
  }, {
    path: "/cashbox/payout-success",
    component: _4b26a46a,
    name: "cashbox-payout-success___ua"
  }, {
    path: "/cashbox/support",
    component: _3dc5129e,
    name: "cashbox-support___ua"
  }, {
    path: "/cashbox/withdrawal",
    component: _7107fcc3,
    name: "cashbox-withdrawal___ua"
  }, {
    path: "/promotions/welcome-pack",
    component: _e8379f42,
    name: "promotions-welcome-pack___ua"
  }, {
    path: "/ru/amlpolicy",
    component: _3623a256,
    name: "content-amlpolicy___ru"
  }, {
    path: "/ru/cashbox",
    component: _00e650b4,
    name: "cashbox___ru"
  }, {
    path: "/ru/error-game",
    component: _76e7056e,
    name: "error-game___ru"
  }, {
    path: "/ru/faq",
    component: _8fe4e58e,
    name: "content-faq___ru"
  }, {
    path: "/ru/game-rules",
    component: _dabf39ee,
    name: "content-game-rules___ru"
  }, {
    path: "/ru/intellectual-property",
    component: _f5defaf6,
    name: "content-intellectual-property___ru"
  }, {
    path: "/ru/license",
    component: _5a67bb64,
    name: "content-license___ru"
  }, {
    path: "/ru/partners",
    component: _c07793d0,
    name: "content-partners___ru"
  }, {
    path: "/ru/privacy-policy",
    component: _572e72c4,
    name: "content-privacy-policy___ru"
  }, {
    path: "/ru/profile",
    component: _bc5f4b3c,
    name: "profile___ru",
    children: [{
      path: "bonuses",
      component: _0a161de3,
      name: "profile-bonuses___ru"
    }, {
      path: "kycaid",
      component: _05920c38,
      name: "profile-kycaid___ru"
    }, {
      path: "settings",
      component: _4f1990e3,
      name: "profile-settings___ru"
    }, {
      path: "support-faq",
      component: _59e814a4,
      name: "profile-support-faq___ru"
    }]
  }, {
    path: "/ru/promotions",
    component: _02b24dca,
    name: "promotions___ru"
  }, {
    path: "/ru/registration",
    component: _45700e60,
    name: "registration___ru"
  }, {
    path: "/ru/responsible-gaming",
    component: _fe2e16da,
    name: "content-responsible-gaming___ru"
  }, {
    path: "/ru/rules",
    component: _50bcfbda,
    name: "content-rules___ru"
  }, {
    path: "/ru/verifications",
    component: _06b43ff4,
    name: "verifications___ru"
  }, {
    path: "/ru/cashbox/deposit",
    component: _3f7c0e00,
    name: "cashbox-deposit___ru"
  }, {
    path: "/ru/cashbox/history",
    component: _6470f0f6,
    name: "cashbox-history___ru"
  }, {
    path: "/ru/cashbox/payin-error",
    component: _a9c0ed2c,
    name: "cashbox-payin-error___ru"
  }, {
    path: "/ru/cashbox/payin-status-ext",
    component: _d306ea58,
    name: "cashbox-payin-status-ext___ru"
  }, {
    path: "/ru/cashbox/payin-success",
    component: _cc191136,
    name: "cashbox-payin-success___ru"
  }, {
    path: "/ru/cashbox/payout-error",
    component: _76d433af,
    name: "cashbox-payout-error___ru"
  }, {
    path: "/ru/cashbox/payout-success",
    component: _4b26a46a,
    name: "cashbox-payout-success___ru"
  }, {
    path: "/ru/cashbox/support",
    component: _3dc5129e,
    name: "cashbox-support___ru"
  }, {
    path: "/ru/cashbox/withdrawal",
    component: _7107fcc3,
    name: "cashbox-withdrawal___ru"
  }, {
    path: "/ru/promotions/welcome-pack",
    component: _e8379f42,
    name: "promotions-welcome-pack___ru"
  }, {
    path: "/ru/game/:term?",
    component: _d4a39b76,
    name: "game-term___ru"
  }, {
    path: "/ru/lobby/:section",
    component: _36a995d4,
    name: "lobby-section___ru",
    children: [{
      path: ":sub-section?",
      component: _43688dbc,
      name: "lobby-section-sub-section___ru"
    }]
  }, {
    path: "/ru/promotions/:term",
    component: _1c71847a,
    name: "promotions-term___ru"
  }, {
    path: "/ru/auth/:social?/cb",
    component: _6892517c,
    name: "auth-social-cb___ru"
  }, {
    path: "/game/:term?",
    component: _d4a39b76,
    name: "game-term___ua"
  }, {
    path: "/lobby/:section",
    component: _36a995d4,
    name: "lobby-section___ua",
    children: [{
      path: ":sub-section?",
      component: _43688dbc,
      name: "lobby-section-sub-section___ua"
    }]
  }, {
    path: "/promotions/:term",
    component: _1c71847a,
    name: "promotions-term___ua"
  }, {
    path: "/ru/:section",
    component: _7b3cc337,
    children: [{
      path: "",
      component: _36a995d4,
      name: "parent-section___ru",
      children: [{
        path: ":sub_section",
        component: _43688dbc,
        name: "sub-section___ru"
      }]
    }]
  }, {
    path: "/auth/:social?/cb",
    component: _6892517c,
    name: "auth-social-cb___ua"
  }, {
    path: "/",
    component: _f3211d6a,
    name: "index___ua"
  }, {
    path: "/:section",
    component: _7b3cc337,
    children: [{
      path: "",
      component: _36a995d4,
      name: "parent-section___ua",
      children: [{
        path: ":sub_section",
        component: _43688dbc,
        name: "sub-section___ua"
      }]
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
